import { environment } from '@env';
import { useApiFetch } from './useApiFetch';

export const useApiServiceForecast = () => {
  const fetchData = useApiFetch();

  const getAssemblies = async () =>
    fetchData(`${environment.BASE_URL}v1/dgs/inference/assembly`);

  const getDryGasSealTags = async datasource_id =>
    fetchData(`${environment.BASE_URL}v1/dgs/inference/${datasource_id}/tags`);

  const getIndependentTags = async datasource_id =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/${datasource_id}/independent_tags`);

  const getDGSInfo = async datasource =>
    fetchData(`${environment.BASE_URL}v1/dgs/assemblies/dgs_speed?DATASOURCE_ID=${datasource}`);

  const getTimeSeriesChartData = async (from, to, datasource, tagAlias, frequency, businessRules) =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/timeseries/v3?from=${from}&to=${to}`,
      'POST',
      {
        DATASOURCE: datasource,
        TAG_ALIAS: tagAlias,
        DATA_FREQ: frequency,
        BUSINESS_RULE: businessRules
      }
    );

  const startForecast = async ({
    tagAlias,
    tagName,
    datasource_id,
    frequency,
    startDate,
    endDate,
    forecastStartDate,
    forecastEndDate,
    name,
    desc,
    businessRules,
    dgsInfo
  }) =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/forecast/`,
      'POST',
      {
        tag_alias: tagAlias,
        tag_name: tagName,
        start_date: startDate,
        end_date: endDate,
        data_freq: frequency,
        forecast_start_date: forecastStartDate,
        forecast_end_date: forecastEndDate,
        CUST_NAME: name,
        CUST_DESC: desc,
        business_rules: businessRules,
        DGS_Info: dgsInfo,
        datasource_id
      }
    );

  const getForecastModelList = async (datasource_id, tagAliasname) =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/forecast-model/forecasts`,
      'POST',
      {
        tag_alias_name: tagAliasname,
        datasource_id
      }
    );

  const getForecastData = async (from, to, model_id) =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/forecast/forecast-data/?from=${from}&to=${to}&forecast_id=${model_id}`,
      'GET'
    );

  const updateForecastModelStatus = async (forecastJobName, status) =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/forecast-model/status-update`,
      'PUT',
      { FORECAST_JOB_NAME: forecastJobName, STATUS: status }
    );

  const deleteForecastModel = async forecastJobName =>
    fetchData(
      `${environment.BASE_URL}v1/dgs/forecast-model/forecast/delete?forecast_job_name=${forecastJobName}`,
      'GET'
    );

  return {
    getAssemblies,
    getDryGasSealTags,
    getIndependentTags,
    getDGSInfo,
    getTimeSeriesChartData,
    startForecast,
    getForecastData,
    getForecastModelList,
    deleteForecastModel,
    updateForecastModelStatus
  };
};
